
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 2h2v18h18v2H2V2zm7 14.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1-4.5a2 2 0 100-4 2 2 0 000 4zm8 1a2 2 0 11-4 0 2 2 0 014 0zm.5-5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"}})])
          )
        }
      }
    